import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/layout/Layout'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import Register from './pages/Register'
import Profile from './pages/Profile'
import Setup from './pages/Setup'
import Settings from './pages/Settings'
import Notifications from './pages/Notifications'
import ActivationCodes from './pages/ActivationCodes'
import StudyModule from './pages/StudyModule'
import StudyPlans from './pages/StudyPlans'

import TimeManagement from './pages/TimeManagement'
// import Goals from './pages/Goals'
import TrialExams from './pages/TrialExams'
import QuestionBank from './pages/QuestionBank'
import ExamResults from './pages/ExamResults'
import PerformanceAnalysis from './pages/PerformanceAnalysis'
import ProgressReport from './pages/ProgressReport'
import BreathingExercises from './pages/BreathingExercises'
import AdminRoute from './components/AdminRoute'


import Notes from './pages/Notes'
import Summaries from './pages/Summaries'
import MindMaps from './pages/MindMaps'

// Flashcard imports
import Flashcards from './pages/Flashcards'
import FlashcardStudy from './pages/FlashcardStudy'
import FlashcardReview from './pages/FlashcardReview'
import FlashcardStats from './pages/FlashcardStats'
import SessionComplete from './pages/SessionComplete'
import AdminFlashcards from './pages/admin/AdminFlashcards'
import CreateFlashcard from './pages/admin/CreateFlashcard'
import AdminSummaryCards from './pages/admin/AdminSummaryCards'
import CreateSummaryCard from './pages/admin/CreateSummaryCard'

import Badges from './pages/Badges'
import Achievements from './pages/Achievements'
import Store from './pages/Store'



import ErrorBoundary from './components/ui/ErrorBoundary'
import ProtectedRoute from './components/ProtectedRoute'

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/setup" element={<Setup />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Study Routes */}
            <Route path="study">
              <Route index element={<StudyModule />} />
              <Route path="plans" element={<StudyPlans />} />

            </Route>
            
            {/* Exam Routes */}
            <Route path="exams">
              <Route path="trials" element={<TrialExams />} />
              <Route path="results" element={<ExamResults />} />
            </Route>
            
            {/* Question Routes */}
            <Route path="questions">
              <Route path="bank" element={<QuestionBank />} />
            </Route>
            
            {/* Tools Routes */}
            <Route path="tools">
              <Route path="notes" element={<Notes />} />
              <Route path="summaries" element={<Summaries />} />
              <Route path="mindmaps" element={<MindMaps />} />
            </Route>
            
            {/* Flashcard Routes */}
            <Route path="flashcards">
              <Route index element={<Flashcards />} />
              <Route path="study/:deckId" element={<FlashcardStudy />} />
              <Route path="review/:subject" element={<FlashcardReview />} />
              <Route path="session-complete/:sessionId" element={<SessionComplete />} />
              <Route path="session-complete/local" element={<SessionComplete />} />
              <Route path="session-complete/review" element={<SessionComplete />} />
              <Route path="stats" element={<FlashcardStats />} />
            </Route>
            
            {/* Time Management */}
            <Route path="pomodoro" element={<TimeManagement />} />
            
            {/* Breathing Exercises */}
            <Route path="tools/breathing" element={<BreathingExercises />} />
            
            {/* Gamification Routes */}
            <Route path="gamification">
              <Route path="badges" element={<Badges />} />
              <Route path="achievements" element={<Achievements />} />
              <Route path="leaderboard" element={<div>Liderlik Tablosu</div>} />
              <Route path="shop" element={<Store />} />
              <Route path="quests" element={<div>Görevler</div>} />
            </Route>
            
            {/* Analytics Routes */}
            <Route path="analytics">
              <Route path="dashboard" element={<div>Analitik Dashboard</div>} />
              <Route path="progress" element={<ProgressReport />} />
              <Route path="time" element={<div>Zaman Analizi</div>} />
              <Route path="subjects" element={<div>Konu Analizi</div>} />
              <Route path="performance" element={<PerformanceAnalysis />} />
            </Route>
            
            {/* Social Routes */}
            <Route path="social">
              <Route path="groups" element={<div>Çalışma Grupları</div>} />
              <Route path="competitions" element={<div>Yarışmalar</div>} />
              <Route path="forum" element={<div>Forum</div>} />
            </Route>
            
            {/* Other Routes */}
            <Route path="notifications" element={<Notifications />} />
            <Route path="help" element={<div>Yardım</div>} />
            <Route path="settings" element={<Settings />} />
            <Route path="profile" element={<Profile />} />
            <Route path="/admin/activation-codes" element={<AdminRoute><ActivationCodes /></AdminRoute>} />
            
            {/* Admin Flashcard Routes */}
            <Route path="admin/flashcards" element={<AdminRoute><AdminFlashcards /></AdminRoute>} />
            <Route path="admin/flashcards/create" element={<AdminRoute><CreateFlashcard /></AdminRoute>} />
            <Route path="admin/flashcards/edit/:deckId" element={<AdminRoute><CreateFlashcard /></AdminRoute>} />
            
            {/* Admin Summary Card Routes */}
            <Route path="admin/summary-cards" element={<AdminRoute><AdminSummaryCards /></AdminRoute>} />
            <Route path="admin/summary-cards/create" element={<AdminRoute><CreateSummaryCard /></AdminRoute>} />
            <Route path="admin/summary-cards/edit/:id" element={<AdminRoute><CreateSummaryCard /></AdminRoute>} />



            
            {/* 404 Route */}
            <Route path="*" element={
              <div className="text-center py-12">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                  404 - Sayfa Bulunamadı
                </h1>
                <p className="text-gray-600 dark:text-gray-400">
                  Aradığınız sayfa mevcut değil.
                </p>
              </div>
            } />
          </Route>
        </Routes>
      </div>
    </ErrorBoundary>
  )
}

export default App